var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.RmpText,{staticClass:"mb-4",attrs:{"type":"title-small","color":_setup.colors.shades.black}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }